<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        <!-- {{ $t('message.add') }} {{ $tc('message.patients', 1) }} -->
                        Transfert des patients d'un médécin a un autre
                    </h3>
                </div>
            </div>

            <div>
                <b-form @submit.prevent="onSubmit"> <!-- @reset="onReset" v-if="show" -->
                    <b-col col sm="12">
                        <div class="row mt-5">
                            <div class="col-xl-3">
                                <h3>{{ $tc('message.OldmedecinReferent',1) }}</h3>
                            </div>
                            <div class="col-md-12 col-lg-6 col-xl-9">
                                <b-form-group
                                        id="ancien_medecin_referent-group"
                                        label-for="ancien_medecin_referent">
                                    <!-- Options -->
                                        <multiselect v-model="$v.form.ancien_medecin_referent.$model" :options="mDoctors" :placeholder="$tc('message.OldmedecinReferent', 1)" selectLabel="Sélectionner" label="nom" track-by="id" @input="getPatientofCurrentDoctor"></multiselect>
                                    <b-form-invalid-feedback v-if="errorshasField('ancien_medecin_referent')">
                                        {{ getErrorsField('ancien_medecin_referent') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-xl-3">
                                <h3>{{ $tc('message.NewmedecinReferent',1) }}</h3>
                            </div>
                            <div class="col-md-12 col-lg-6 col-xl-9">
                                <b-form-group
                                        id="nouveau_medecin_referent-group"
                                        label-for="nouveau_medecin_referent">
                                    <!-- Options -->
                                        <multiselect v-model="$v.form.nouveau_medecin_referent.$model" :options="mDoctors" :placeholder="$tc('message.NewmedecinReferent', 1)" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>

                                    <b-form-invalid-feedback v-if="errorshasField('nouveau_medecin_referent')">
                                        {{ getErrorsField('nouveau_medecin_referent') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>
                            </div>
                        </div>
                        
                        <div>
                            <!-- <b-row class="mt-1"> -->
                                <!-- <b-col md="9" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante"> -->
                                    
                                    
                                <!-- </b-col> -->
                                <!-- <b-col md="3" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                    <b-link class="ml-2" variant="primary">@click="onAddReferent"
                                        <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.add', 1) }}
                                    </b-link> 
                                </b-col>  -->
                            <!-- </b-row> -->

                            
                            <!-- <b-row class="mt-1"> -->
                                <!-- <b-col md="9" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante"> -->
                                    
                                    
                                <!-- </b-col> -->
                                <!-- <b-col md="3" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                    <b-link class="ml-2" variant="primary"> @click="onAddReferent"
                                        <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.add', 1) }}
                                    </b-link> 
                                </b-col>  -->
                            <!-- </b-row> -->
                            <b-row>
                                <b-col md="9" sm="6">
                                    <b-form-group label="Transférer tout les patients ?">
                                        <b-form-radio-group id="transfert" v-model="$v.form.transferer.$model" name="patients">
                                            <b-form-radio value="Oui">Oui</b-form-radio>
                                            <b-form-radio value="Non">Non</b-form-radio>
                                        </b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <!-- <b-row v-if="form.patients=='Non'">
                                <b-col md="9" sm="6" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                    <b-form-group
                                            id="patients-group"
                                            label-for="patients">
                                            <multiselect v-model="$v.form.patients.$model" :options="patients" :placeholder="$tc('message.medecinReferent', 1)" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>

                                        <b-form-invalid-feedback v-if="errorshasField('patients')">
                                            {{ getErrorsField('patients') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>
                                    
                                </b-col>
                            </b-row> -->
                            <b-row v-if="form.transferer=='Non'">
                                <div class="col-xl-3">
                                    <h3>Patient(s)</h3>
                                </div>
                                
                                <b-col class="col-md-12 col-lg-6 col-xl-9" v-if="hasAdminRole || hasMedecinControleRole || hasAssistante">
                                    <b-form-group
                                            id="patients-group"
                                            label-for="patients">
                                            <multiselect v-model="$v.form.patients.$model" :options="patients" :multiple="true" placeholder="Sélectionner le ou les patient(s)" selectLabel="Sélectionner" label="nom" track-by="id"></multiselect>

                                        <b-form-invalid-feedback v-if="errorshasField('patients')">
                                            {{ getErrorsField('patients') }}
                                        </b-form-invalid-feedback>

                                    </b-form-group>
                                    
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>

                    <b-container>
                        <div class="d-flex justify-content-center" v-if="is_loading">
                            <div class="loading"></div>
                        </div>
                        <b-row class="justify-content-center" v-else>
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.transferer') }}
                            </b-button>

                            <!--                                <b-button type="reset" variant="danger">-->
                            <!--                                    {{ $t('message.reset') }}-->
                            <!--                                </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer,maxLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import Multiselect from 'vue-multiselect'
    import moment from "moment";
    import Swal from 'sweetalert2';
    import AppConfig from '../../constants/AppConfig';
    import axios from "axios";

    export default {
        name: "AddPatient",
        components:{
            Multiselect
        },

        computed: {
            ...mapGetters(["countries", "subsc  ribers", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole','hasAssistante',
                'hasSouscripteurRole',
                'hasAssistante','controlDoctors'
            ]),

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },


            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasSouscripteurRole || this.hasAssistante;
            },
            mDoctors: function() {
                let dArray = [];

                _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
                    let d = {};
                    if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
                        let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        d.id = doctor.user.id;

                        if (d.nom.length >0){
                            dArray.push(d);
                        }
                    }

                });
                return dArray;
            },
        },

        data() {
            return {
                patients: [],
                show: true,
                is_loading: false,
                form: {
                    nouveau_medecin_referent: "",
                    ancien_medecin_referent: "",
                    transferer: 'Oui',
                    patients: "",
                    is_loading: false
                },
            }
        },
        watch:{

        },

        methods: {
            getDoctors() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };
                this.$store.dispatch('getControlDoctors', { args : args });
            },

            getPatientofCurrentDoctor() {
                if(this.form.ancien_medecin_referent.id != undefined){
                    axios.get(`${AppConfig.apiUrl}/recuperation-patients/`+ this.form.ancien_medecin_referent.id, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
                    .then(res=>{   
                        this.patients = res.data.patients;
                    })
                }
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();
                this.is_loading = true;

                if(!this.$v.$invalid ) {
                    if(this.form.patients.length > 0 && this.form.transferer == 'Non'){
                        let args = {
                            ancien_medecin_referent: this.form.ancien_medecin_referent.id,
                            nouveau_medecin_referent: this.form.nouveau_medecin_referent.id,
                            patients: this.form.patients.map(item => item.id)
                        };
                    if(args.ancien_medecin_referent == args.nouveau_medecin_referent){
                        this.is_loading = false;
                        Swal.fire({
                            title: 'Attention !',
                            text: "Le nouveau médécin référent doit être différent de l'ancien",
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#00ada7',
                            cancelButtonColor: '#f5365c',
                            confirmButtonText: 'Ok'
                        })
                    } else {
                        // console.log(args);
                        
                                axios.post(`${AppConfig.apiUrl}/transfert-patient-medecin-referent`, args, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': "Bearer " + localStorage.getItem('ms-token')
                                    }
                                }).then(res => {
                                    if(res.data.nouveau_medecin_referent != null){
                                        Swal.fire({
                                            title: "Opération réussie",
                                            text: "Le transfert a été modifier avec succès",
                                            icon: 'success',
                                        })
                                        // this.$router.push({ name: 'UserInfo' });
                                        // this.$router.push({ name: 'SouscripteurDashboard'});
                                        this.$router.go(this.$router.currentRoute)
                                    }else{
                                        Swal.fire({
                                            title: "Erreur",
                                            icon: 'error',
                                        })
                                        this.is_loading = false;
                                    }

                                }).catch(error => {
                                    console.log('error ', error);
                            }) 
                        }
                    }else {
                        let args = {
                            ancien_medecin_referent: this.form.ancien_medecin_referent.id,
                            nouveau_medecin_referent: this.form.nouveau_medecin_referent.id,
                            // patients: this.form.patients.map(item => item.id)
                        };
                        

                        if(args.ancien_medecin_referent == args.nouveau_medecin_referent){
                            this.is_loading = false;
                        Swal.fire({
                            title: 'Attention !',
                            text: "Le nouveau médécin référent doit être différent de l'ancien",
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#00ada7',
                            cancelButtonColor: '#f5365c',
                            confirmButtonText: 'Ok'
                        })
                    } else {
                        this.is_loading = true;
                                axios.post(`${AppConfig.apiUrl}/transfert-patient-medecin-referent`, args, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': "Bearer " + localStorage.getItem('ms-token')
                                    }
                                })
                                .then(res => {
                                    if(res.data.nouveau_medecin_referent != null){
                                        Swal.fire({
                                            title: "Opération réussie",
                                            text: "Le transfert a été modifier avec succès",
                                            icon: 'success',
                                        })
                                        // this.$router.push({ name: 'UserInfo' });
                                        this.$router.go(this.$router.currentRoute)
                                    }else{
                                        Swal.fire({
                                            title: "Erreur",
                                            icon: 'error',
                                        })
                                        this.is_loading = false;
                                    }

                                }).catch(error => {
                                    console.log('error ', error);
                            }) 
                        }
                    }


                    

                    // let successMessage = this.$i18n.t('message.patientCreated');
                    // let errorMessages = {
                    //     generic: this.$i18n.t('message.genericError'),
                    //     error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    // };
                    // this.$store.dispatch('createPatient', { args, errorMessages, successMessage })
                    // .then(() => {
                    //     // Scroll to the top of the page
                    //     document.body.scrollTop = 0; // For Safari
                    //     document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    // });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.ancien_medecin_referent = '';
                this.form.nouveau_medecin_referent = '';
                this.form.patients = '';
                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations() {
            return {
                form: {
                    ancien_medecin_referent:'',
                    nouveau_medecin_referent:'',
                    patients: {},
                    transferer:''
                }
            }
        },
        created() {
        
        },
        mounted() {
            this.getDoctors();
            // new SlimSelect({
            //     select: '#ancien_medecin_referent',
            //     placeholder: 'Select manager',
            //     // limit: 1
            // });
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>